import { defineComponent as _defineComponent } from 'vue'
import FormField from './fields/FormField.vue';
import FormSection from './FormSection.vue';
import CallTextBalloon from '../../common/components/CallTextBalloon.vue';
import { BaseFormModel, isFormType } from '../interfaces/form';
import { computed, ref } from 'vue';
import { useFormElement } from '../composables/useFormElement';
import { makeUseFormElementEmits, makeUseFormElementProps } from '../composables/useFormElementInterfaces';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormElement',
  props: makeUseFormElementProps<BaseFormModel>(),
  emits: makeUseFormElementEmits(),
  setup(__props, { expose, emit }) {

const props = __props;





const item = ref<InstanceType<typeof FormField>>();

const { modelStateRef, getModelState, model, field, getSlotName } = useFormElement({
  emit,
  props,
});

const formWrapperClass = modelStateRef('formWrapperClass', '', true);

const fieldWrapperClass = modelStateRef('fieldWrapperClass', '', true);

const callText = modelStateRef('callText');

const showCallText = modelStateRef('showCallText', true, true);

const isForm = computed(() => {
  return isFormType(getModelState('fieldType'));
});

const hidden = computed(() => {
  const hidden = getModelState('hidden', false);

  return typeof hidden === 'function' ? hidden(model) : hidden;
});

function triggerFieldAction(path: string, action: any) {
  if (item.value?.triggerFieldAction) {
    item.value.triggerFieldAction(path, action);
  }
}

expose({
  triggerFieldAction,
});

return { __sfc: true,props, emit, item, modelStateRef, getModelState, model, field, getSlotName, formWrapperClass, fieldWrapperClass, callText, showCallText, isForm, hidden, triggerFieldAction, FormField, FormSection, CallTextBalloon }
}

})